import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * The standalone Call Log page is a tab of Agents → Voice now. Legacy links, including
 * deep-link params like `?drawer=`, land on that tab so existing bookmarks keep working.
 */
export default function CallLogRedirect() {
  const [searchParams] = useSearchParams()
  const params = new URLSearchParams(searchParams)
  params.set(`tab`, `Call Log`)
  return <Navigate to={`/agents/voice?${params.toString()}`} replace />
}
